import { AnnotationsCommandVersionsService_annotationCommandVersionsServiceGetQuery } from '@festina/legalentity-general-types/legalentity/hooks/AnnotationsCommandVersionsService_annotationCommandVersionsServiceGetQuery'

export const useFetchAnnotationCommands =
  AnnotationsCommandVersionsService_annotationCommandVersionsServiceGetQuery.useSuspenseQuery
